import { DateValue, DatesRangeValue } from '@mantine/dates';
import { getRangeDate } from '../datePickerHelper';

type OutsourcingReportDateParams = {
  dateFrom?: string;
  dateTo?: string;
};

export function buildOutsourcingReportDateParams(
  dateRange: DatesRangeValue
): OutsourcingReportDateParams {
  const [from, to] = dateRange;
  if (!from && !to) {
    return {
      dateFrom: undefined,
      dateTo: undefined,
    };
  }

  const normalizedRange: [DateValue, DateValue] = [from || to, to || from];
  const { fromDate, toDate } = getRangeDate(normalizedRange);

  return {
    dateFrom: fromDate,
    dateTo: toDate,
  };
}
